module.exports = __webpack_public_path__ + "static/media/defaultblue.fd65af96.svg";